var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystemUiconsCreate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 16.7622L6.854 23.6194C6.854 24.4277 7.17509 25.2028 7.74663 25.7744C8.31817 26.3459 9.09334 26.667 9.90162 26.667L23.6159 26.667C24.4242 26.667 25.1994 26.3459 25.7709 25.7744C26.3424 25.2028 26.6635 24.4277 26.6635 23.6194L26.6635 8.38128C26.6635 7.573 26.3424 6.79783 25.7709 6.22629C25.1994 5.65475 24.4242 5.33366 23.6159 5.33366L16.7588 5.33366",
    stroke: "white",
    strokeOpacity: 0.48,
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37688 8.38179L9.90069 6.9296M5.27898 5.33417C5.69865 4.92721 6.26163 4.70179 6.84619 4.70663C7.43076 4.71148 7.98992 4.94621 8.40279 5.36008L19.0435 16.0008L20.5674 20.5723L15.9959 19.0485L5.25917 8.4016C4.8823 8.02713 4.65753 7.52631 4.62826 6.99584C4.599 6.46537 4.7673 5.94287 5.10069 5.52922L5.27898 5.33417Z",
    stroke: "white",
    strokeOpacity: 0.48,
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemUiconsCreate);
export default __webpack_public_path__ + "static/media/system-uicons_create.7f4ae79dede86ab7e51a26c9df5ac3a1.svg";
export { ForwardRef as ReactComponent };